import { Card } from "@devhop/ui";
import { AlertTriangle } from "lucide-react";
import type { AuditSummaryStats } from "@/modules/internal-audit/domain/repo/summary/get-stats";

type AuditSummaryFrequentlyFailedProps = {
  stats: AuditSummaryStats;
};

export function AuditSummaryFrequentlyFailed({
  stats,
}: AuditSummaryFrequentlyFailedProps) {
  const { frequentlyFailedItems } = stats;

  if (frequentlyFailedItems.length === 0) return null;

  const maxCount = Math.max(...frequentlyFailedItems.map((item) => item.count), 1);

  return (
    <Card className="p-6" data-tourid="summary-frequently-failed">
      <div className="mb-4 flex items-center gap-2">
        <AlertTriangle className="h-5 w-5 text-orange-500" />
        <h2 className="font-semibold text-lg">
          ເລື່ອງທີ່ບໍ່ຜ່ານບໍ່
        </h2>
      </div>
      <div className="space-y-3">
        {frequentlyFailedItems.map((item) => (
          <div key={item.title} className="space-y-1">
            <div className="flex items-center justify-between text-sm">
              <span className="font-medium">{item.title}</span>
              <span className="text-muted-foreground">
                {item.count} ຄັ້ງ ({item.percentage}%)
              </span>
            </div>
            <div className="h-4 w-full overflow-hidden rounded-full bg-muted">
              <div
                className="h-full bg-orange-500 transition-all"
                style={{ width: `${(item.count / maxCount) * 100}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}

